<template>
  <funding-base :state="state" :current-funding-pot-id="state.funding_pot.id">
    <div class="container pt-12">
      <template v-if="!applicationCount">
        <div class="border-4 border-dashed p-12 text-center max-w-md mx-auto">
          <h1>No assessments available</h1>
          <p>Before assessments can begin, you first need to import all submitted applications. We recommend doing this after the application window has closed.</p>
          <div class="w-32 mx-auto mt-6">
            <app-button
              :disabled="importing"
              @click="importApplications"
            >
              {{ importing ? 'Importing' : 'Import' }}
            </app-button>
          </div>
        </div>
      </template>
      <template v-else-if="markingPhases.length">
        <article
          v-for="phase in markingPhases"
          :key="phase.id"
          class="pl-4 pr-6 py-4 flex items-center bg-white shadow-lg relative border-b border-grey-200 last:border-0"
        >
          <div class="flex-1 flex items-center">
            <button
              class="mr-4 w-10 h-10 flex items-center justify-center text-white rounded-full transition-all transition-fast focus:outline-none focus:shadow-outline"
              :class="{
                'bg-negative-500' : phase.locked,
                'bg-positive-500' : !phase.locked
              }"
              @click="lockGrading(phase.id, phase.locked)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="w-4 h-4"
              ><path
                v-if="phase.locked"
                d="M18 10v-4c0-3.313-2.687-6-6-6s-6 2.687-6 6v4h-3v14h18v-14h-3zm-10 0v-4c0-2.206 1.794-4 4-4s4 1.794 4 4v4h-8z"
              /><path
                v-else
                d="M12 10v-4c0-3.313-2.687-6-6-6s-6 2.687-6 6v3h2v-3c0-2.206 1.794-4 4-4s4 1.794 4 4v4h-4v14h18v-14h-12z"
              /></svg>
              <span class="sr-only">{{ phase.locked ? 'Unlock' : 'Lock' }}</span>
            </button>
            <div>
              <h2 class="text-xl leading-tight truncate">
                {{ phase.name }}
              </h2>
              <p
                v-if="phase.continuation_of_marking_phase_id"
                class="text-xs"
              >
                Continuation of {{ continuationOf(phase.continuation_of_marking_phase_id, 'name') }}.
              </p>
            </div>
          </div>
          <nav class="flex-no-shrink flex text-sm font-bold">
            <a
              v-if="!phase.continuation_of_marking_phase_id"
              :href="route('funding.assessments.assessors', { funding: $page.funding_pot.id, phase: phase.id })"
              class="ml-2 block border border-grey-300 px-4 py-2 uppercase text-grey-800 no-underline hover:border-primary-500 hover:bg-primary-100 hover:text-primary-700"
            >
              Assessors
              <template v-if="phase.assessors.length">
                ({{ phase.assessors.length }})
              </template>
            </a>
            <a
              :href="route('funding.assessments.phase', { funding: $page.funding_pot.id, phase: phase.id })"
              class="ml-2 block border border-grey-300 px-4 py-2 uppercase text-grey-800 no-underline hover:border-primary-500 hover:bg-primary-100 hover:text-primary-700"
            >
              League Table
            </a>
            <a
              :href="route('funding.assessments.review', { funding: $page.funding_pot.id, phase: phase.id })"
              class="ml-2 block border border-grey-300 px-4 py-2 uppercase text-grey-800 no-underline hover:border-primary-500 hover:bg-primary-100 hover:text-primary-700"
            >
              Review
            </a>
          </nav>
        </article>
      </template>
      <template v-else>
        No Marking phases
      </template>
    </div>
  </funding-base>
</template>

<script>
export default {
    name: 'FundingAssessmentsIndex',
    data(){
      return {
        importing: false,
        markingPhases: this.state.marking_phases ?? []
      }
    },
    computed: {
      applicationCount() {
        return this.markingPhases.reduce((count, phase) => {
          if(phase.applications) {
            count += phase.applications.length
          }
          return count
        }, 0)
      },
    },
    methods: {
      lockGrading(phaseId, value) {
        axios
          .post(route("funding.assessments.phase.locking", [this.state.funding_pot.id, phaseId]), {
            lock: !value
          }).then(() => {
            this.markingPhases.find(phase => phase.id === phaseId).locked = !value
          })
      },
      importApplications() {

        if(this.importing || this.applicationCount) return

        this.importing = true
        axios({
          method: 'post',
          url: window.location.href
        }).then(({data}) => {
          this.markingPhases[0].applications = data.applications
          this.loading = false
        })
      },
      continuationOf(phaseId, key = "id") {
        return this.markingPhases.find(phase => phase.id === phaseId)?.[key] ?? '[ERROR]';
      }
    },
}
</script>
